"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Divider = require("./Divider.styles");
/**
 * @since 8.38.0
 */

var Divider = function Divider(props) {
  return /*#__PURE__*/_react.default.createElement(_Divider.StyledDivider, props);
};
exports.Divider = Divider;
Divider.displayName = 'Divider';
Divider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The appearance of a divider.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.DIVIDER_APPEARANCES)),
  /**
   * The length of a divider.
   *
   * Supports inline media query objects.
   */
  length: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(Object.values(_constants.DIVIDER_LENGTHS))),
  /**
   * The orientation of a divider.
   *
   * Supports inline media query objects.
   */
  orientation: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(Object.values(_constants.ORIENTATIONS))),
  /**
   * A [role](https://www.w3.org/TR/wai-aria-1.2/#roles) is required for assistive
   * technologies to announce the divider properly. Divider uses the
   * [separator](https://www.w3.org/TR/wai-aria-1.2/#separator) role.
   */
  role: _propTypes.default.string
} : {};
Divider.defaultProps = {
  appearance: _constants.DIVIDER_APPEARANCES.regular,
  length: _constants.DIVIDER_LENGTHS.auto,
  orientation: _constants.ORIENTATIONS.horizontal,
  role: 'separator'
};